<template>
    <v-row class="text-center" justify="space-around" height='90vh' style="margin: 0 0">
      <v-col cols='12' v-if="!playing">
        <v-row class="text-center">
          <v-col cols='12'>
            <h1>SELECT AN OPTION</h1>
          </v-col>
        </v-row>
        <v-row class="text-center" justify="space-around" height='90vh' style="margin: 0 0">
          <v-btn text color='green' @click='$router.push("battleCardsPlay")'>Play</v-btn>
          <v-btn text color='orange' @click='$router.push("battleCardsDeckBuilder")'>Build Deck</v-btn>
          <v-btn text color='blue' @click='$router.push("battleCardsBuyPacks")'>Buy Cards</v-btn>
          <v-btn text color='purple'>Rules</v-btn>
        </v-row>
        <v-row class="text-center" justify="space-around" height='90vh' style="margin: 0 0">
            <v-img
            src="https://i.imgur.com/7ikfNea.jpg"
            class="white--text align-center"
            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
            height="50vh"
          >
            <h1>BATTLE CARDS</h1>
          </v-img>
        </v-row>
      </v-col>
    </v-row>
</template>

<script>
  export default {
    name: 'xChangeBattle',
    data: () => ({
      playing: false,
    }),
    computed: {
      activeBattleCardsDeck () {
        return this.$store.state.activeBattleCardsDeck.sort(function(a, b) {
          var textA = a.title.toUpperCase();
          var textB = b.title.toUpperCase();
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      });
      }
    },
    methods:{

    }
  }
</script>

<style scoped>

</style>